import CordovaModule from '../modules/yptCordova'

export default angular.module('flatastic.fileSystem', [
  CordovaModule,
])

.factory('FileSystem', ['yptCordova', '$window', function(yptCordova, $window) {

  return {
    getFileBlob,
    getLocalFilePath,
  }

  ////

  function getLocalFilePath(fileURL) {
    if (fileURL.constructor === File) {
      return (URL.createObjectURL || window.webkitURL)(fileURL)
    }
    if (ionic.Platform.isIOS()) {
      return WkWebView.convertFilePath(fileURL)
    }
    return fileURL
  }

  function getFileBlob(fileURL) {
    return resolvePath(fileURL)
      .then(getFileFromFileEntry)
      .then(createBlob)
  }

  function getFileFromFileEntry(fileEntry) {
    return new Promise(resolve => fileEntry.file(resolve))
  }

  function createBlob(file) {
    return new Promise((resolve) => {
      const reader = new FileReader()
      reader.onloadend = function() {
        const blob = new Blob([new Uint8Array(this.result)], { type: file.type })
        resolve(blob)
      }
      reader.readAsArrayBuffer(file)
    })
  }

  function resolvePath(path) {
    return yptCordova.ready.then(() => new Promise((resolve, reject) => {
      if (!$window.resolveLocalFileSystemURL) {
        console.warn('window.resolveLocalFileSystemURL is not defined')
        return reject('window.resolveLocalFileSystemURL is not defined')
      }
      return resolveLocalFileSystemURL(path, resolve, reject)
    }))
  }

}])

.name;
